// extracted by mini-css-extract-plugin
export default {"container":"info_entry_container__+XZjX","label":"info_entry_label__UTHVC","content":"info_entry_content__v9kTf"};